import { AppBar, Dialog, DialogContent, IconButton, Toolbar, Typography, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Close } from '@mui/icons-material'
import QuestionnaireTemplateGrid from '../QuestionnaireTemplates/QuestionnaireTemplate/QuestionnaireTemplateGrid'

const QuestionnaireTemplateListModal = ({handleClose,onSelect }) => {
    const {t} = useTranslation()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    
  return (
    <>
     <Dialog 
    fullScreen={isMobile}
    fullWidth
     open={true} 
     onClose={handleClose} 
     PaperProps={{
        sx: {
          maxWidth: "none",
          width: 1200,
          height: { md: 650 }
        }
      }}
     >
        <AppBar position='relative' sx={{ boxShadow: 'none' }}>
                <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClose}
                    aria-label="close"
                  >
                    <Close />
                  </IconButton>
                  <Typography sx={{ ml: 2 }} variant="h6" component="div">
                    {t("general.template")}
                  </Typography>
                </Toolbar>
              </AppBar>
        <DialogContent>         
          <QuestionnaireTemplateGrid onSelect={(row) => {
            onSelect(row);
            handleClose();
          }}
          isModal={true}
          />
      </DialogContent>
     </Dialog>
    </>
  )
}

export default QuestionnaireTemplateListModal
